import Button from '@/components/UI/Button';
import Image from '@/components/UI/Image';
import EFArrowLeft from '@/components/UI/svg/Icons/EFArrowLeft';
import { useGlobal } from '@/utils/useGlobal';
import { TimelineMax, TweenMax } from 'gsap';
import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import styled from './index.module.scss';
const imglist = [
    {
        direction: 'right',
        arr: [] as string[],
    },
    {
        direction: 'left',
        arr: [] as string[],
    },
];
imglist.map((item, index) => {
    let direction = true;
    if (index === 1) direction = false;
    let i = 1;
    while (i <= 10) {
        item.arr.push(`/img/stories/common/taste/${direction ? i : 11 - i}.jpg`);
        i++;
    }
});

const StoryNewTaste = () => {
    const { useState, useEffect, isMobile, useLang, Link } = useGlobal();
    const [showFirst, setShowFirst] = useState(false);
    const [showNext, setShowNext] = useState(false);
    let controller = null;
    const { t } = useLang('brandstory');
    const [swiper, setSwiper] = useState(null);
    const contentlist = [
        {
            left: t('newtaste.paraga'),
            right: t('newtaste.paragb'),
        },
        {
            left: t('newtaste.paragc'),
            right: t('newtaste.paragd'),
        },
    ];

    // useEffect(() => {
    //   let winHeight = window.innerHeight || document.body.clientHeight
    // }, [])

    useEffect(() => {
        controller = new ScrollMagic.Controller();

        const sceneA = new ScrollMagic.Scene({
            triggerElement: '.storyNewtaste', //触发元素
            offset: -700, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 500, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA1 = TweenMax.to(`.storyNewtaste .header`, 0.25, { opacity: 1, ease: 'none' });
        sceneA.setTween(tweenA1);

        const sceneB = new ScrollMagic.Scene({
            triggerElement: '.storyNewtaste', //触发元素
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 500, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const tweenB0 = TweenMax.to(`.storyNewtaste .header`, 0.25, { opacity: 0, y: -200 });
        const tweenB1 = TweenMax.to(`.storyNewtaste .left`, 0.3, { opacity: 1, y: 0 });
        const tweenB2 = TweenMax.to(`.storyNewtaste .right`, 0.3, { opacity: 1, y: 0 });
        const tweenB3 = TweenMax.to(`.storyNewtaste .imganimation`, 0.3, { opacity: 1 });
        const tweenB4 = TweenMax.to(`.storyNewtaste .link-border`, 0.3, { opacity: 1 });

        const timelineB1 = new TimelineMax();
        timelineB1.add(tweenB0, 0).add(tweenB1, 0.25).add(tweenB2, 0.3).add(tweenB3, 0.3).add(tweenB4, 0.3);
        sceneB.setTween(timelineB1);

        controller.addScene(sceneA).addScene(sceneB);
    }, []);
    return (
        <div id="storyNewtaste" className={`${isMobile ? styled.story_mobile_newtaste : styled.story_newtaste} storyNewtaste`}>
            <div className="story_newtaste__sticky">
                <div className={`${showNext ? 'hidden' : ''} header content`}>
                    <h5 className="screen-title">{t('menu.newtaste')}</h5>
                    <h5 className="screen-desc">{t('newtaste.title')}</h5>
                </div>
                <div className={`${showNext ? 'show' : ''} nextscreen`}>
                    {contentlist.map((item, index) => (
                        <div className="content text" key={index}>
                            <p className="left">{item.left}</p>
                            <p className="right">{item.right}</p>
                        </div>
                    ))}
                    <div className="imganimation">
                        {imglist.map((item, index) => (
                            <Swiper
                                loop
                                speed={4000}
                                freeMode={true}
                                modules={[Autoplay]}
                                effect="coverflow"
                                className="imglist"
                                key={index}
                                spaceBetween={10}
                                slidesPerView={'auto'}
                                navigation={false}
                                pagination={false}
                                scrollbar={false}
                                autoplay={{
                                    delay: 0,
                                    disableOnInteraction: false,
                                    reverseDirection: item.direction === 'right',
                                }}
                                onSwiper={(swiper) => setSwiper(swiper)}
                            >
                                {item.arr.map((img, imgIndex) => (
                                    <SwiperSlide className="imgitem" key={imgIndex}>
                                        <Image src={img} layout="fill" className="fullImgs" alt="" aria-label="" />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        ))}
                    </div>
                    <div className="link-border">
                        <Link href="https://jp.ecoflow.com/pages/emergency-food-restaurant-lifeplate-02" target="_blank">
                            <Button shape="circle" className="link-btn font-family-medium" aria-label={t('newtaste.btntext')} style={{ color: '#000' }}>
                                {t('newtaste.btntext')}
                                <span className="more">
                                    <EFArrowLeft />
                                </span>
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StoryNewTaste;
